import { gql, useMutation } from '@apollo/client';

import { GET_VACANCIES } from './get-vacancies.hook';

export const CREATE_VACANCY_PATTERN = gql`
  mutation createVacancyPattern($payload: AddVacancyPatternInput!) {
    createVacancyPattern(payload: $payload) {
      _id
    }
  }
`;

export const useCreateVacancyPattern = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createVacancyPattern, { loading }] = useMutation(CREATE_VACANCY_PATTERN, {
    refetchQueries: [GET_VACANCIES],
    onCompleted: onSuccess,
  });

  return { createVacancyPattern, loading };
};
